<template lang="pug">
div.tirant-prime-conversa
  div.conversa_expanded_button(@click.stop="openConversa")
    span.badge.badge-pill.badge-primary.badge__conversa {{ t("conversa.promotion.conversa_users") }}
    .conversa__container
      .conversaHome.d-flex.flex-column.flex-lg-row.align-items-center.justify-content-around.gap-4
        img.conversaHome__logo(:src="imageUrl('logo_Conversa_Color.png')")
        .conversaHome__buttonContainer.d-flex.flex-column.gap-3.position-relative
          .conversaHome__button.conversaHome__button-principal.hvr-shrink(
            :aria-disabled="isLoading"
            :class="{ 'button-disabled': isLoading }"
            @click.stop="openConversa"
            v-bind="trackData('chat_option')"
            data-cy="conversa-button"
          )
            .conversaHome__button-principal-icon
              i.fas.fa-comments
            .conversaHome__button-principal-content
              h6.conversaHome__button-principal-title {{ buttonName('chat_option') }}
          .d-flex.flex-column.flex-lg-row.gap-3
            .conversaHome__button.conversaHome__button-secondary.hvr-shrink(
              @click.stop="openFileUpload"
              :aria-disabled="isLoading"
              :class="{ 'button-disabled': isLoading }"
              v-bind="trackData('upload_option')"
              data-cy="file-upload-button"
            )
              .conversaHome__button-secondary-icon
                loader-vue.button-loader-orange(v-if="isUploadLoading" :visible="true" size="small")
                i.fas.fa-cloud-upload-alt(v-else)
              .conversaHome__button-secondary-content
                h6.conversaHome__button-secondary-title {{ buttonName('upload_option') }}

            .conversaHome__button.conversaHome__button-secondary.hvr-shrink(
              @click.stop="openNewDocument"
              :aria-disabled="isLoading"
              :class="{ 'button-disabled': isLoading }"
              v-bind="trackData('new_document_option')"
              data-cy="new-document-button"
            )
              .conversaHome__button-secondary-icon
                loader-vue.button-loader-orange(v-if="isNewDocLoading" :visible="true" size="small")
                i.fas.fa-plus(v-else)
              .conversaHome__button-secondary-content
                h6.conversaHome__button-secondary-title {{ buttonName('new_document_option') }}
</template>

<script>
import { mapMutations } from 'vuex'
import mixins from 'common/mixins.js'
import SofiaUploaderMixin from 'common/mixins/uploader_mixin'
import { trackButtonClickHandler } from 'common/tracking'
import Loader from "components/Loader"

export default {
  name: 'tirant-prime-conversa-vue',
  mixins: [mixins.translate, mixins.requests, SofiaUploaderMixin],
  components: {
    'loader-vue': Loader
  },
  data() {
    return {
      isUploadAction: false,
      isNewDocAction: false
    }
  },
  computed: {
    isLoading() {
      return this.creating_file || this.uploading_file || this.time_out_request
    },
    isUploadLoading() {
      return this.isUploadAction && this.isLoading
    },
    isNewDocLoading() {
      return this.isNewDocAction && this.isLoading
    }
  },
  watch: {
    isLoading(newVal) {
      if (!newVal) {
        this.isUploadAction = false
        this.isNewDocAction = false
      }
    }
  },
  props: {
    statsEnabled: { type: Boolean, default: false }
  },
  methods: {
    ...mapMutations('conversa', ['setShowConversa']),
    openConversa(event) {
      trackButtonClickHandler(event)
      this.setShowConversa(true)
    },
    openFileUpload(event) {
      if (this.isLoading) return
      this.isUploadAction = true
      this.isNewDocAction = false
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = '.pdf,.txt,.rtf,.doc,.docx,.odt,.html,.ott,.sxw'
      input.onchange = (event) => {
        this.onChange(event)
      }
      trackButtonClickHandler(event)
      input.click()
    },
    openNewDocument(event) {
      if (this.isLoading) return
      trackButtonClickHandler(event)
      this.isUploadAction = false
      this.isNewDocAction = true
      this.new_document('')
    },
    imageUrl(name) {
      return require('../../../assets/images/conversa/' + name)
    },
    buttonName(button, forceLocale = false) {
      if (forceLocale) {
        return this.t('conversa.tirant_prime_conversa.' + button, { locale: forceLocale })
      }
      return this.t('conversa.tirant_prime_conversa.' + button)
    },
    trackData(button) {
      if (!this.statsEnabled) return {}

      return {
        'data-track-category': this.t('tracking.home.category', { locale: 'es' }),
        'data-track-action': this.t('tracking.home.action.conversa', { locale: 'es' }),
        'data-track-name': this.buttonName(button, 'es')
      }
    }
  }
}
</script>
